export const FETCH_EVENTS = 'FETCH_EVENTS'

export const FETCH_EVENTS_SUCCESS = 'FETCH_EVENTS_SUCCESS'
export const FETCH_EVENTS_FAILURE = 'FETCH_EVENTS_FAILURE'

export const UPDATE_ATTENDING_EVENT = 'UPDATE_ATTENDING_EVENT'
